import { render, staticRenderFns } from "./pickingTasks1.vue?vue&type=template&id=0955cc8b&scoped=true&"
import script from "./pickingTasks1.vue?vue&type=script&lang=js&"
export * from "./pickingTasks1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0955cc8b",
  null
  
)

export default component.exports